// Shared brand constants for Recorrido 360
export const BRAND = {
  name: "Recorrido 360",
  logoHorizontal:
    "https://customer-assets.emergentagent.com/job_a0b05377-7043-4db8-bfcb-1f428365b5f1/artifacts/kd7qj0wh_1.png",
  logoVertical:
    "https://customer-assets.emergentagent.com/job_a0b05377-7043-4db8-bfcb-1f428365b5f1/artifacts/4vgz0cy8_2.png",
  // Latest user-supplied logo (colorful swirl ring, December 2025)
  logoIcon:
    "https://customer-assets.emergentagent.com/job_immersive-sales-hub/artifacts/pnwt7gd3_Imagen7772.png",
};

export const CONTACT = {
  whatsappNumber: "+54 9 3512 16-9145",
  whatsappLink:
    "https://wa.me/5493512169145?text=" +
    encodeURIComponent(
      "Hola Recorrido 360, me interesa agendar una asesoría gratuita para mi negocio."
    ),
  email: "hola@recorrido360.net",
  address: "Calle Rivadavia 63. Córdoba - Argentina",
};

export const KUULA = {
  // Hero shows restaurant tour (updated)
  hero: "https://kuula.co/share/collection/7PnMy?logo=1&info=1&fs=1&vr=0&gyro=0&thumbs=1",
  // Demo section shows real-estate / agencia inmobiliaria (original)
  demo: "https://kuula.co/share/collection/7llBr?logo=1&info=1&fs=1&vr=0&gyro=0&thumbs=1",
};

export const NAV_LINKS = [
  { href: "#beneficios", label: "Beneficios" },
  { href: "#industrias", label: "Industrias" },
  { href: "#demo", label: "Demostración" },
  { href: "#proceso", label: "Proceso" },
  { href: "#contacto", label: "Contacto" },
];
